import React, { useState } from "react";
import { Button, Card, Divider, Spin } from "antd";
import OrderList from "../OrderList/orderlist";
import OrderStatus from "../OrderStatus/orderstatus";
import axios from "axios";
import config from "../config";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import Receipt from "../Receipt/Receipt";
import CryptoPayment from "../Payment/Bitcoin";
import Express from "../Express/Express";
import WesterUnion from "../Payment/WesterUnion";
import BitcoinPaymentIntro from "../Payment/BitcoinPaymentIntro";
import Paypal from "../Payment/Paypal";
// Function to aggregate data
function groupByProductType(data) {
  const result = [];
  const groupedData = {};

  data.forEach((item) => {
    const productName = item.product.state;
    const productPrice = parseFloat(item.product.price); // Ensure price is numeric

    // If product type hasn't been added to groupedData, create a new object
    if (!groupedData[productName]) {
      groupedData[productName] = {
        name: item.product.name,
        quantity: 0,
        price: productPrice, // Initialize total price
      };
    }

    // Update product quantity
    groupedData[productName].quantity += 1;
  });
  for (const [key, value] of Object.entries(groupedData)) {
    result.push({
      key: key,
      name: value.name,
      price: value.price,
      quantity: value.quantity,
    });
  }

  return result;
}

const OrderDetailElement = ({ checkout_hash }) => {
  const [order_status, setOrderStatus] = useState("waiting_payment");
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [orderData, setOrderData] = useState({
    orderId: "",
    date: "",
    items: [],
    total: 0,
    payment_address: "",
    tracking_number: "",
    tracking_info: [],
    checkout_hash: "",
    paypal_payer_full_name: "",
    paypal_payer_email: "",
    paypal_transaction_id: "",
    paypal_actual_amount_after_fee: "",
    paypal_note: "",
    shipping_fullname: "",
    shipping_address: "",
    shipping_city: "",
    shipping_state: "",
    shipping_country: "",
    shipping_zip: "",
    shipping_phone: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${config.baseUrl}/api/orderdetail/${checkout_hash}/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        if (response.data.length === 0) {
          navigate("/orderform");
        } else {
          setOrderStatus(response.data["order_status"]);
          setProducts(response.data["cart_items"]);
          //set orderId
          const groupedProducts = groupByProductType(
            response.data["cart_items"]
          );
          setOrderData({
            orderId: response.data["order_number"],
            date: response.data["date"],
            items: groupedProducts,
            total: response.data["checkout_price"],
            actual_discount_amount: response.data["actual_discount_amount"],
            payment_address: response.data["payment_address"],
            tracking_info: response.data["tracking_info"],
            tracking_number: response.data["tracking_number"],
            payment_method: response.data["payment_method"],
            checkout_hash: response.data["checkout_hash"],
            paypal_payer_full_name: response.data["paypal_payer_full_name"],
            paypal_payer_email: response.data["paypal_payer_email"],
            paypal_transaction_id: response.data["paypal_transaction_id"],
            paypal_actual_amount_after_fee:
              response.data["paypal_actual_amount_after_fee"],
            paypal_note: response.data["paypal_note"],
            shipping_fullname: response.data["shipping_fullname"],
            shipping_address: response.data["shipping_address"],
            shipping_city: response.data["shipping_city"],
            shipping_state: response.data["shipping_state"],
            shipping_country: response.data["shipping_country"],
            shipping_zip: response.data["shipping_zip"],
            shipping_phone: response.data["shipping_phone"],
          });
        }
      } catch (error) {
        message.error("Error fetching data:", error);
        navigate("/orderform");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [checkout_hash, navigate]);
  return (
    <Spin spinning={loading} tip="Loading...">
      <Card
        title={
          <span style={{ fontSize: "30px", fontWeight: "bold" }}>
            Order Detail
          </span>
        }
        style={{ width: "93%", maxWidth: 1200, margin: "15px auto" }}
        hoverable
      >
        <Receipt orderData={orderData} />
        <Divider />
        {orderData.payment_method === "bitcoin_payment" && (
          <CryptoPayment bitcoinAddress={orderData.payment_address} />
        )}
        {orderData.payment_method === "western_union" && <WesterUnion />}
        {orderData.payment_method === "bitcoin_payment" && (
          <BitcoinPaymentIntro />
        )}
        {orderData.payment_method === "paypal" && (
          <Paypal orderData={orderData} />
        )}
        <Divider />
        <Card title="Order Status" hoverable>
          <OrderStatus status={order_status} />
        </Card>
        <Divider />
        {orderData?.tracking_info &&
          Object.keys(orderData.tracking_info).length > 0 && (
            <>
              <Express
                tracking_info={orderData.tracking_info}
                tracking_number={orderData.tracking_number}
              />
              <Divider />
            </>
          )}
        <Card title="Order List">
          <OrderList products={products} />
        </Card>
        <Divider />
        <Button
          type="primary"
          onClick={() => navigate("/myorder")}
          style={{ width: "100%", height: "50px" }}
        >
          Back to My Order
        </Button>
      </Card>
    </Spin>
  );
};

export default OrderDetailElement;
